import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  close: {
    id: 'universals.close',
    defaultMessage: 'Zavřít',
  },
  back: {
    id: 'universals.back',
    defaultMessage: 'Zpět',
  },
});
